<template>
  <div>
    <div class="container">
      <div class="row">
        <div class="col-md-6 offset-md-3 text-center">
          <h1 v-if="this.user" class="title">Hi {{ user.first_name }},</h1>
          <h1 v-else class="title">Activate your account</h1>

          <div v-if="isLoggedIn">
            <p class="regular">Welcome to Resolute!</p>
            <p class="mb-0">Your account is now ready.</p>
            <p class="small">Why not set a password to your new account:</p>
            <router-link class="btn btn-primary mt-2" :to="{ name: 'password-change' }">Set new password</router-link>
            <hr class="space space-xs">
            <router-link class="btn mt-2" :to="{ name: 'dashboard' }">Go to Dashboard</router-link>
          </div>
          <div v-else-if="isLoading" class="text-center">
            <hr class="space space-sm">
            <loader size="128px"></loader>
            <p class="small muted pt-4">One moment, just setting things up...</p>
          </div>
          <div v-else-if="hasError">
            <hr class="space space-sm">
            <p class="small error pt-4">{{ errorInfo }}</p>
          </div>

          <hr class="space space-sm">
        </div>
      </div>
    </div>
    <hr class="divider">
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'activate',
  props: ['code'],
  data () {
    return {
      form: {
        password: null
      },
      isLoading: true,
      hasError: false,
      errorInfo: null
    }
  },
  computed: {
    ...mapState({
      isLoggedIn: state => state.auth.isLoggedIn,
      user: state => state.auth.user
    })
  },
  mounted () {
    window.scrollTo(0, 0)
    if (this.code) {
      this.activate()
    } else {
      this.isLoading = false
    }
  },
  methods: {
    activate () {
      this.isLoading = true
      this.$store
        .dispatch('ACTIVATE', this.code)
        .then((response) => {
        })
        .catch(error => {
          console.log(error)
          this.hasError = true
          this.errorInfo = 'Something didn\'t work. Please try again.'
        })
    }
  }
}
</script>
